import RailsResource from './rails-resource';

class CommissionService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'commissions',
      ajaxLoader: false
    });
  }

  validate(expression, variables) {
    return this.post(`${this.url}/${this.resource}/validate.json`, true, {
      query: expression,
      variables: variables
    });
  }
}

export default new CommissionService();